/* FIL price layout lock v3
 * 锁 PDP 价格区高度，杜绝变体切换时的布局抖动。
 * 关键：不监听 style/class 属性变化（否则改 style 会自触发 observer 死循环，导致卡顿）。
 * 只用 ResizeObserver 防抖守卫高度突变。 */
(function () {
  var SEL = '.product-pricing';
  var LOCKED_H = null;
  var restoring = false;   // 防止 restore 改 style 再触发 RO 形成循环

  function getEls() {
    return document.querySelectorAll(SEL);
  }

  function lock(el) {
    var h = Math.ceil(el.getBoundingClientRect().height);
    if (h <= 0) return;
    LOCKED_H = h;
    el.setAttribute('data-fil-lock', String(h));
    el.style.minHeight = h + 'px';
    el.style.height = h + 'px';
    el.style.overflow = 'hidden';
    el.style.display = 'block';
  }

  function restore(el) {
    if (LOCKED_H == null || restoring) return;
    var h = el.getBoundingClientRect().height;
    if (Math.abs(h - LOCKED_H) > 2) {
      restoring = true;
      el.style.height = LOCKED_H + 'px';
      el.style.minHeight = LOCKED_H + 'px';
      el.style.overflow = 'hidden';
      // 下一帧解除，让 RO 的本次回调安全结束
      requestAnimationFrame(function () { restoring = false; });
    }
  }

  function remeasureAll() {
    var els = document.querySelectorAll('[data-fil-lock]');
    for (var i = 0; i < els.length; i++) {
      els[i].removeAttribute('data-fil-lock');
      els[i].style.height = '';
      els[i].style.minHeight = '';
      els[i].style.overflow = '';
    }
    LOCKED_H = null;
    var cur = getEls();
    for (var j = 0; j < cur.length; j++) lock(cur[j]);
  }

  var ro;
  function watchAll() {
    var els = getEls();
    for (var i = 0; i < els.length; i++) {
      if (!els[i].hasAttribute('data-fil-watched')) {
        els[i].setAttribute('data-fil-watched', '1');
        if (ro) ro.observe(els[i]);
      }
    }
  }

  function init() {
    remeasureAll();
    if (window.ResizeObserver) {
      ro = new ResizeObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          restore(entries[i].target);
        }
      });
      watchAll();
    }
    // 字体/加载完成后重测（仅几次，不会循环）
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { setTimeout(remeasureAll, 100); });
    }
    window.addEventListener('load', function () { setTimeout(remeasureAll, 300); });
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(remeasureAll, 200);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
